import React from 'react';
import { PremiumHitsTable } from 'javascripts/analytics/components/premium_hits_table';

export class PremiumHitsTableContainer extends React.Component {
  getStateFromStore = () => {
    return {
      hits: Aedu.ReduxStore.getState().AnalyticsDashboard.Hits,
    };
  };

  state = this.getStateFromStore();

  componentDidMount() {
    this.unsubscribe = Aedu.ReduxStore.subscribe(
      function () {
        this.setState(this.getStateFromStore());
      }.bind(this),
    );

    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Hits.fetch(),
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    return <PremiumHitsTable hits={this.state.hits.models} />;
  }
}
